import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";
import CountUp from "react-countup";
import Benchmark from "./Benchmark";
import { API_URL } from "../actions/auth";

export default function NewsPage(props) {
  const state = useSelector((state) => state);

  const location = useLocation();
  console.log(location.state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('https://images.unsplash.com/photo-1614850523011-8f49ffc73908?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')",
          }}
        >
          <div
            style={{
              textAlign: "justify",
              fontSize: state.auth.isMobile ? "20px" : "38px",
              fontFamily: "Montserrat",
              color: "white",
              fontWeight: "bold",
              marginBottom: "15px",
              marginTop: state.auth.isMobile ? "50px" : "50px",
            }}
          >
            {location.state.title}
          </div>
          <div
            style={{
              textAlign: "center",
              fontSize: state.auth.isMobile ? "18px" : "28px",
              fontFamily: "Montserrat",
              color: "white",
            }}
          >
            {location.state.subtitle}
          </div>
        </div>
        <div className="aboutabout" style={{ marginTop: "100px" }}>
          <div
            style={{
              width: state.auth.isMobile ? "100%" : "70%",
              height: state.auth.isMobile ? "70vh" : "80vh",
            }}
          >
            <div className="slider">
              <div className="slides-container">
                <div className="slides-inner">
                  {!location.state.image1.includes("default") ? (
                    <div className="slide">
                      {" "}
                      <img
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          margin: "10px",
                          height: "100%",
                        }}
                        src={API_URL + "media/" + location.state.image1}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {!location.state.image2.includes("default") ? (
                    <div className="slide">
                      {" "}
                      <img
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          margin: "10px",
                          height: "100%",
                        }}
                        src={API_URL + "media/" + location.state.image2}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {!location.state.image3.includes("default") ? (
                    <div className="slide">
                      {" "}
                      <img
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          margin: "10px",
                          height: "100%",
                        }}
                        src={API_URL + "media/" + location.state.image3}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {!location.state.image4.includes("default") ? (
                    <div className="slide">
                      {" "}
                      <img
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          margin: "10px",
                          height: "100%",
                        }}
                        src={API_URL + "media/" + location.state.image4}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {!location.state.image5.includes("default") ? (
                    <div className="slide">
                      {" "}
                      <img
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          margin: "10px",
                          height: "100%",
                        }}
                        src={API_URL + "media/" + location.state.image5}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {!location.state.image6.includes("default") ? (
                    <div className="slide">
                      {" "}
                      <img
                        style={{
                          width: "100%",
                          objectFit: "cover",
                          margin: "10px",
                          height: "100%",
                        }}
                        src={API_URL + "media/" + location.state.image6}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <div
                className="controls"
                style={{ display: state.auth.isMobile ? "none" : "block" }}
              >
                <Button
                  className="button-carousel"
                  id="prevButton"
                  style={{
                    border: "2px solid " + themeStyle.primaryColor,
                    borderRadius: "25px",
                    height: "30px",
                    fontSize: "15px",
                    color: themeStyle.primaryColor,
                    fontWeight: "bold",
                    padding: "2px 10px 0px 10px",
                  }}
                >
                  Prev
                </Button>

                <Button
                  className="button-carousel"
                  id="nextButton"
                  style={{
                    marginLeft: "15px",
                    border: "2px solid " + themeStyle.primaryColor,
                    borderRadius: "25px",
                    height: "30px",
                    fontSize: "15px",
                    color: themeStyle.primaryColor,
                    fontWeight: "bold",
                    padding: "2px 10px 0px 10px",
                  }}
                >
                  Next
                </Button>
              </div>
            </div>
          </div>
          <div
            style={{
              textAlign: "justify",
              width: state.auth.isMobile ? "100%" : "50%",
              marginTop: "50px",
              fontSize: state.auth.isMobile ? "16px" : "20px",
              fontFamily: "Montserrat",
              marginBottom: "100px",
            }}
          >
            <div dangerouslySetInnerHTML={{ __html: location.state.content }} />
          </div>
        </div>

        <Benchmark />
        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
